import analytics from "./segment";
import bugsnagClient, { identify as bugsnagIdentify } from "./bugsnag";
import trackFirstMeaningfulPaint from "./performance/firstMeaningfulPaint";
/**
 * Identify the user to Segment and Bugsnag
 *
 * @param userUid The user's PlanGrid UID
 * @param traits A CAPI or Cacahuete-like User object
 */
const identify = (userUid, traits) => {
  analytics.identify(userUid, traits);
  bugsnagIdentify(userUid, traits);
};
const setBaseProperties = analytics.setBaseProperties;
const track = analytics.track;
const notify = bugsnagClient.notify;
export { identify, notify, setBaseProperties, track, bugsnagClient };
export { default as MockAnalyticsStore } from "./MockAnalyticsStore";
export { trackFirstMeaningfulPaint };
